var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1504_3316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.822266,
    y: 0.18457,
    width: 19.7431,
    height: 19.7431,
    rx: 9.87154,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1504_3316)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1504_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5308 9.78997L17.6663 9.20621L17.6664 9.20615L17.1574 8.36818C15.1935 5.13528 10.7516 4.53062 7.99475 7.12061L6.77781 8.26417C6.6626 8.37242 6.51905 8.44584 6.36382 8.47583L4.40024 8.8554C4.3096 8.87286 4.22167 8.89725 4.13705 8.92827L3.48656 9.94141L3 11.5306V12.0217C3 12.1864 3.13346 12.3199 3.29811 12.3199H17.6898C17.8609 12.3199 18 12.181 18 12.0097V10.8341L17.7976 10.7178L17.5308 9.78997Z",
    fill: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23225 12.2632V11.2849C5.23225 10.5495 5.69568 9.9057 6.3693 9.66089C6.45392 9.62987 6.54184 9.60548 6.63248 9.58802L8.5961 9.20845C8.75133 9.17845 8.89487 9.10504 9.01009 8.99678L10.227 7.85323C11.5809 6.58133 13.3413 6.08035 15.0148 6.28225C12.8369 5.04727 9.97917 5.25623 7.99478 7.12056L6.77784 8.26411C6.66263 8.37237 6.51908 8.44578 6.36385 8.47578L4.40024 8.85532C4.3096 8.87278 4.22167 8.89717 4.13705 8.92819L3.48656 9.94133L3 11.5305V12.0217C3 12.1863 3.13346 12.3198 3.29811 12.3198H5.23225V12.2632Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60133 11.0216C6.72606 11.0216 6.82718 10.9205 6.82718 10.7958V8.21777L6.77779 8.26418C6.6655 8.36969 6.5262 8.44178 6.37549 8.47316V10.7958C6.37549 10.9205 6.47661 11.0216 6.60133 11.0216Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8718 11.9885C12.7471 11.9885 12.646 11.8873 12.646 11.7626V7.83229C12.646 7.70756 12.7471 7.60645 12.8718 7.60645C12.9966 7.60645 13.0977 7.70756 13.0977 7.83229V11.7626C13.0977 11.8873 12.9966 11.9885 12.8718 11.9885Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13705 8.92773V11.5301H3V10.5517C3 9.81636 3.46343 9.17255 4.13705 8.92773Z",
    fill: "#FED402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 9.91611V10.8339H16.5464V9.84474V9.42527C16.5464 9.30422 16.6446 9.20605 16.7656 9.20605H17.6663L17.9159 9.61679C17.9707 9.70683 17.9999 9.81041 17.9999 9.91611Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.2594V12.0095C18 12.1808 17.8609 12.3196 17.6898 12.3196H3.29842C3.1337 12.3196 3 12.1862 3 12.0215V10.8405H3.57816C3.9898 10.1711 4.72877 9.72363 5.57071 9.72363C6.63339 9.72363 7.53285 10.437 7.81531 11.4099C7.82404 11.4401 7.85144 11.4611 7.88276 11.4611L13.4924 11.4614C13.5238 11.4614 13.5509 11.4404 13.5599 11.4099C13.8423 10.437 14.7415 9.72363 15.8045 9.72363C16.8118 9.72363 17.6721 10.3641 18 11.2594Z",
    fill: "#FEDF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57072 13.494C6.36243 13.494 7.00423 12.8522 7.00423 12.0605C7.00423 11.2688 6.36243 10.627 5.57072 10.627C4.77901 10.627 4.13721 11.2688 4.13721 12.0605C4.13721 12.8522 4.77901 13.494 5.57072 13.494Z",
    fill: "#736572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8046 13.494C16.5963 13.494 17.2381 12.8522 17.2381 12.0605C17.2381 11.2688 16.5963 10.627 15.8046 10.627C15.0129 10.627 14.3711 11.2688 14.3711 12.0605C14.3711 12.8522 15.0129 13.494 15.8046 13.494Z",
    fill: "#736572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57072 12.0605C5.57072 11.53 5.85953 11.0669 6.28788 10.819C6.07697 10.6969 5.83191 10.627 5.57072 10.627C4.77903 10.627 4.13721 11.2687 4.13721 12.0605C4.13721 12.8522 4.779 13.494 5.57072 13.494C5.83191 13.494 6.07712 13.4239 6.288 13.3019C5.85968 13.054 5.57072 12.591 5.57072 12.0605Z",
    fill: "#615260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8046 12.0605C15.8046 11.53 16.0934 11.0668 16.5217 10.819C16.3108 10.6969 16.0658 10.627 15.8046 10.627C15.0129 10.627 14.3711 11.2687 14.3711 12.0605C14.3711 12.8522 15.0129 13.494 15.8046 13.494C16.0658 13.494 16.3105 13.4242 16.5213 13.3022C16.093 13.0543 15.8046 12.591 15.8046 12.0605Z",
    fill: "#615260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 12.5905C15.5122 12.5905 15.2744 12.3527 15.2744 12.0604C15.2744 11.7681 15.5122 11.5303 15.8045 11.5303C16.0969 11.5303 16.3347 11.7681 16.3347 12.0604C16.3347 12.3527 16.0969 12.5905 15.8045 12.5905Z",
    fill: "#B8B2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9023 12.5815C15.8392 12.42 15.8045 12.2442 15.8045 12.0604C15.8045 11.8766 15.8393 11.7008 15.9024 11.5393C15.8704 11.5333 15.8382 11.5303 15.8045 11.5303C15.5122 11.5303 15.2744 11.7681 15.2744 12.0604C15.2744 12.3527 15.5122 12.5905 15.8045 12.5905C15.8382 12.5905 15.8704 12.5875 15.9023 12.5815Z",
    fill: "#9E959E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4631 6.60547L13.084 6.81686V8.09114L13.4405 8.4047H16.0254C16.0523 8.4047 16.0677 8.37359 16.0512 8.35239C15.3934 7.50722 14.4903 6.89819 13.4631 6.60547Z",
    fill: "#B8DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3901 6.42581L12.3904 6.41979C10.9989 6.32976 9.63927 6.81517 8.61333 7.77908L8.04981 8.30846C8.01322 8.34281 8.03755 8.40421 8.08772 8.40421H12.1945L12.1945 8.40433L12.1947 8.40421H12.3901L12.6623 8.18319V8.12152V6.79015L12.3901 6.42581Z",
    fill: "#B8DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61333 7.77905L8.04981 8.30843C8.01322 8.34279 8.03755 8.40419 8.08772 8.40419H9.64072L10.2271 7.85319C10.8942 7.22646 11.66 6.78729 12.4655 6.52679L12.3901 6.42582L12.3904 6.4198C10.9989 6.32973 9.63927 6.81515 8.61333 7.77905Z",
    fill: "#91CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0494 9.39212H11.7429C11.6182 9.39212 11.5171 9.291 11.5171 9.16627C11.5171 9.04155 11.6182 8.94043 11.7429 8.94043H12.0494C12.1741 8.94043 12.2752 9.04155 12.2752 9.16627C12.2752 9.291 12.1741 9.39212 12.0494 9.39212Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4631 6.60511L13.4405 8.40434H12.3901V6.42594L12.3904 6.41992C12.5106 6.42745 12.631 6.4398 12.7515 6.45606C12.9939 6.48918 13.2318 6.53917 13.4631 6.60511Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63244 9.58808L6.82718 9.55044V8.21777L6.77779 8.26418C6.6655 8.36969 6.5262 8.44178 6.37549 8.47316V9.65884C6.45821 9.62885 6.544 9.60512 6.63244 9.58808Z",
    fill: "#FEE45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57066 12.5905C5.27833 12.5905 5.04053 12.3527 5.04053 12.0604C5.04053 11.7681 5.27833 11.5303 5.57066 11.5303C5.86296 11.5303 6.10076 11.7681 6.10076 12.0604C6.10079 12.3527 5.86296 12.5905 5.57066 12.5905Z",
    fill: "#B8B2B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66853 12.5814C5.60538 12.42 5.57066 12.2442 5.57066 12.0604C5.57066 11.8766 5.60538 11.7008 5.6685 11.5393C5.63655 11.5333 5.60436 11.5303 5.57066 11.5303C5.27833 11.5303 5.04053 11.7681 5.04053 12.0604C5.04053 12.3527 5.27833 12.5905 5.57066 12.5905C5.60433 12.5905 5.63655 12.5875 5.66853 12.5814Z",
    fill: "#9E959E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1504_3316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.441ae5edbaccaa1a474f6dfae2854367.svg";
export { ForwardRef as ReactComponent };